import * as Sentry from "@sentry/react";

if ( import.meta.env.PROD ) {
    Sentry.init( {
        dsn: "https://e032086bcffdab37a365d6653a1a7d2e@o4510596443406336.ingest.de.sentry.io/4510596445175888",
        // Adds request headers and IP for users, for more info visit:
        // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
        sendDefaultPii: true,
        ignoreErrors: [
            // Thrown by a script some Android WebViews/tablet browsers inject
            // into the page (only <anonymous> frames, never our code).
            "Error invoking post: Method not found",
        ],
        integrations: [
        // If you're using react router, use the integration for your react router version instead.
        // Learn more at
        // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
            Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
            Sentry.browserTracingIntegration(),
            Sentry.openFeatureIntegration(),
            Sentry.replayIntegration({
                maskAllText: false,
            }),
            Sentry.feedbackIntegration({
            // Chatwoot now covers the user-facing "report a problem" flow;
            // keep the integration for TechSupportPopup's manual
            // Sentry.getFeedback().createForm() call, but stop it from
            // auto-injecting its own floating trigger button site-wide.
                autoInject: false,
                isNameRequired: true,
                colorScheme: "light",
                triggerLabel: "Сообщить об ошибке",
                triggerAriaLabel: "Сообщить об ошибке",
                formTitle: "Сообщить об ошибке",
                submitButtonLabel: "Отправить отчёт",
                cancelButtonLabel: "Отмена",
                confirmButtonLabel: "Подтвердить",
                addScreenshotButtonLabel: "Добавить скриншот",
                removeScreenshotButtonLabel: "Удалить скриншот",
                nameLabel: "Имя пользователя",
                namePlaceholder: "Ваш никнейм lichess",
                emailLabel: "Email",
                emailPlaceholder: "your.email@example.org",
                isRequiredLabel: "(обязательно)",
                messageLabel: "Описание",
                messagePlaceholder: "В чём проблема? Что вы ожидали?",
                successMessageText: "Спасибо за ваш отчёт!",
                // Screenshot annotation tools (SDK v10.10.0+)
                highlightToolText: "Выделить",
                hideToolText: "Скрыть",
                removeHighlightText: "Удалить",
                showBranding: false,
            }),
        ],
        // Enable logs to be sent to Sentry
        enableLogs: true,
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for tracing.
        // Learn more at
        // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
        tracesSampleRate: 0.5,
        // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
        tracePropagationTargets: [ /^\//, /^https:\/\/chess\.auringontalo\.fi\/api/ ],
        replaysSessionSampleRate: 0.05, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.

    } );
}
